export class ValidFeatureSystem {

  constructor(
    public id?: string,
    public name?: string,

  ) {
  }
}
